import React, { useState } from "react";
import Header from "../../components/header/Header";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { Fade } from "react-reveal";
import "./ContactComponent.css";
import { greeting, contactPageData } from "../../portfolio.js";

const ContactData = contactPageData.contactSection;

function Contact(props) {
  const theme = props.theme;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.message.trim()
    ) {
      setStatus({
        type: "error",
        message: "Please fill in your name, email and message.",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email.trim())) {
      setStatus({
        type: "error",
        message: "Please enter a valid email address.",
      });
      return;
    }

    setSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch("/api/contact-submissions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to send message");
      }

      setStatus({
        type: "success",
        message:
          "Thanks for reaching out! Your details have been saved and I will get back to you soon.",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error(error);
      setStatus({
        type: "error",
        message:
          "Something went wrong while sending your message. Please try again or email me directly at jeevathangavelss@gmail.com.",
      });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      <Header theme={theme} setTheme={props.setTheme} />
      <div
        className={`contact-main main-content ${
          theme.name === "light" ? "light" : "dark"
        }`}
      >
        <div className="basic-contact">
          <Fade bottom duration={1000} distance="40px">
            <div className="contact-heading-div">
              <div className="contact-heading-img-div">
                <img
                  className="profile-pic"
                  src={require(`../../assests/images/${ContactData["profile_image_path"]}`)}
                  alt=""
                />
              </div>
              <div className="contact-heading-text-div">
                <h1 className="contact-heading-text">{ContactData["title"]}</h1>
                <p
                  className="contact-header-detail-text"
                  style={{ color: theme.secondaryText }}
                >
                  {ContactData["description"]}
                </p>
                <SocialMedia />
                {greeting.resumeLink && (
                  <a
                    className="general-btn"
                    href={greeting.resumeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    See my Resume
                  </a>
                )}
              </div>
            </div>
          </Fade>
          <div className="contact-form-wrapper">
            <h2 className="contact-form-title">Send me a message</h2>
            <p
              className="contact-form-subtitle"
              style={{ color: theme.secondaryText }}
            >
              Fill out the form below and your details will be stored so I can
              review and get back to you.
            </p>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-row">
                <div className="contact-form-field">
                  <label htmlFor="name">Name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    className="contact-input"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                    disabled={submitting}
                    required
                  />
                </div>
                <div className="contact-form-field">
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="contact-input"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={submitting}
                    required
                  />
                </div>
              </div>
              <div className="contact-form-field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  className="contact-textarea"
                  rows="5"
                  placeholder="What would you like to talk about?"
                  value={formData.message}
                  onChange={handleChange}
                  disabled={submitting}
                  required
                />
              </div>
              {status.message && (
                <div
                  className={`contact-status ${
                    status.type === "success" ? "success" : "error"
                  }`}
                >
                  {status.message}
                </div>
              )}
              <button
                type="submit"
                className="general-btn contact-submit-btn"
                disabled={submitting}
              >
                {submitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
